/*
 * Public API Surface of ngx-lib/rich-html-textarea
 */
export * from './rich-html-textarea.module';
export * from './rich-html-textarea.component';
